function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//@ts-nocheck
import React from 'react';
import { Animated, StyleSheet } from 'react-native';
import { MeasureElement, Point } from "../../devsupport";
import { ChevronDown } from "../shared/chevronDown.component";
import { MenuItem } from "./menuItem.component";
const CHEVRON_DEG_COLLAPSED = -180;
const CHEVRON_DEG_EXPANDED = 0;
const CHEVRON_ANIM_DURATION = 200;
const POSITION_OUTSCREEN = Point.outscreen();
/**
 * A group of items displayed in Menu.
 * Groups should be rendered within Menu and contain MenuItem components to provide a useful navigation component.
 *
 * @extends React.Component
 *
 * @property {ReactElement<MenuItemProps> | ReactElement<MenuItemProps>[]} children -
 * Items to be rendered within group.
 *
 * @property {ReactText | (TextProps) => ReactElement} title - String, number or a function component
 * to render within the group.
 * If it is a function, expected to return a Text.
 *
 * @property {(ImageProps) => ReactElement} accessoryLeft - Function component
 * to render to start of the *title*.
 * Expected to return an Image.
 *
 * @property {(ImageProps) => ReactElement} accessoryRight - Function component
 * to render to end of the *title*.
 * Expected to return an Image.
 *
 * @property {TouchableOpacityProps} ...TouchableOpacityProps - Any props applied to TouchableOpacity component.
 *
 * @overview-example MenuGroups
 */

export class MenuGroup extends React.Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "state", {
      submenuHeight: 1
    });

    _defineProperty(this, "expandAnimation", new Animated.Value(0));

    _defineProperty(this, "onPress", () => {
      if (this.hasSubmenu) {
        const expandValue = this.expandAnimationValue > 0 ? 0 : this.state.submenuHeight;
        this.createExpandAnimation(expandValue).start();
      }
    });

    _defineProperty(this, "onSubmenuMeasure", frame => {
      this.setState({
        submenuHeight: frame.size.height
      });
    });

    _defineProperty(this, "createExpandAnimation", toValue => {
      return Animated.timing(this.expandAnimation, {
        toValue: toValue,
        duration: CHEVRON_ANIM_DURATION,
        useNativeDriver: false
      });
    });

    _defineProperty(this, "renderAccessoryIfNeeded", evaProps => {
      if (!this.hasSubmenu) {
        return null;
      }

      const style = StyleSheet.flatten(evaProps.style);
      return /*#__PURE__*/React.createElement(Animated.View, {
        style: {
          transform: [{
            rotate: this.expandToRotateInterpolation
          }]
        }
      }, /*#__PURE__*/React.createElement(ChevronDown, _extends({}, evaProps, {
        fill: style.tintColor
      })));
    });

    _defineProperty(this, "renderItemsWithDefaultProps", () => {
      return React.Children.map(this.props.children, item => {
        return /*#__PURE__*/React.cloneElement(item, this.defaultItemProps, null);
      });
    });

    _defineProperty(this, "renderGroupedItems", evaStyle => {
      return /*#__PURE__*/React.createElement(Animated.View, {
        style: [styles.submenu, this.submenuStyle, evaStyle]
      }, this.renderItemsWithDefaultProps());
    });

    _defineProperty(this, "renderMeasuringGroupedItems", evaStyle => {
      return /*#__PURE__*/React.createElement(MeasureElement, {
        onMeasure: this.onSubmenuMeasure
      }, this.renderGroupedItems(evaStyle));
    });

    _defineProperty(this, "renderGroupedItemsIfNeeded", evaStyle => {
      if (!this.hasSubmenu) {
        return null;
      }

      if (this.shouldMeasureSubmenu) {
        return this.renderMeasuringGroupedItems(evaStyle);
      }

      return this.renderGroupedItems(evaStyle);
    });
  }

  get hasSubmenu() {
    return React.Children.count(this.props.children) > 0;
  }

  get shouldMeasureSubmenu() {
    return this.state.submenuHeight === 1;
  }

  get expandAnimationValue() {
    // @ts-ignore - private api, but let's us avoid creating animation listeners.
    // `this.expandAnimation.addListener`
    return this.expandAnimation._value;
  }

  get expandToRotateInterpolation() {
    return this.expandAnimation.interpolate({
      inputRange: [-this.state.submenuHeight, CHEVRON_DEG_EXPANDED],
      outputRange: [`${CHEVRON_DEG_COLLAPSED}deg`, `${CHEVRON_DEG_EXPANDED}deg`]
    });
  }

  get submenuStyle() {
    // @ts-ignore - issue of `@types/react-native` package
    return this.shouldMeasureSubmenu ? styles.outscreen : {
      height: this.expandAnimation
    };
  }

  get defaultItemProps() {
    return {
      appearance: 'grouped'
    };
  }

  render() {
    const _this$props = this.props,
          {
      children
    } = _this$props,
          itemProps = _objectWithoutProperties(_this$props, ["children"]);

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuItem, _extends({
      accessoryRight: this.renderAccessoryIfNeeded
    }, itemProps, {
      onPress: this.onPress
    })), this.renderGroupedItemsIfNeeded({}));
  }

}
const styles = StyleSheet.create({
  outscreen: {
    position: 'absolute',
    left: POSITION_OUTSCREEN.x,
    top: POSITION_OUTSCREEN.y
  },
  submenu: {
    overflow: 'hidden'
  }
});